<template>
    <div class="float-left">
        <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
            <div slot="modal-title">
                Prestação de Contas Final -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
                <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label for="codTipoPrestacaoContas" class="required">Tipo da Prestação</label>
                        <b-input-group>
                            <b-form-select
                                id="codTipoPrestacaoContas"
                                type="text"
                                :options="tiposPrestacoes"
                                value-field="key"
                                text-field="label"
                                v-model="prestacaoContasFinalLancamento.codTipoPrestacaoContas">
                            </b-form-select>
                            <b-form-invalid-feedback>O Tipo da Prestação é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label for="Acao" class="required">Ações</label>
                        <b-input-group>
                            <b-form-select
                                id="Acao"
                                type="text"
                                :options="acoes"
                                text-field="descricao"
                                value-field="idAcaoConvenio"
                                v-model="prestacaoContasFinalLancamento.idAcaoConvenio">
                            </b-form-select>
                            <b-form-invalid-feedback>A Ação é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label for="NaturezaDespesa" class="required">Natureza da Despesa</label>
                        <b-input-group>
                            <b-form-select
                                id="NaturezaDespesa"
                                type="text"
                                :options="naturezas"
                                text-field="descricao"
                                value-field="idNaturezaDespesa"
                                v-model="prestacaoContasFinalLancamento.idNaturezaDespesa">
                            </b-form-select>
                            <b-form-invalid-feedback>A Natureza é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="vcDocumento" class="required">Nº Documento</label>
                        <b-input-group>
                            <b-form-input
                                id="vcDocumento"
                                type="text"
                                v-model="prestacaoContasFinalLancamento.vcDocumento">
                            </b-form-input>
                            <b-form-invalid-feedback>Documento é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="9">
                    <b-form-group>
                        <label for="vcFavorecido" class="required">Favorecido</label>
                        <b-input-group>
                            <b-form-input
                                id="vcFavorecido"
                                type="text"
                                v-model="prestacaoContasFinalLancamento.vcFavorecido">
                            </b-form-input>
                            <b-form-invalid-feedback>Favorecido é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="dtEmissao" class="required">Data Emissão</label>
                        <b-input-group>
                            <date-picker
                                id="dtEmissao"
                                v-model="prestacaoContasFinalLancamento.dtEmissao"
                                :config="$datePickerOptions"
                                @input.native="$v.convenio.dtInicioVigencia.$touch()"
                                v-mask="'##/##/####'">
                            </date-picker>
                            <b-form-invalid-feedback>Data Emissão é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="dtPagamento">Data Pagamento</label>
                        <b-input-group>
                            <date-picker
                                id="dtPagamento"
                                v-model="prestacaoContasFinalLancamento.dtPagamento"
                                @input.native="$v.convenio.dtInicioVigencia.$touch()"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'">
                            </date-picker>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuValor">Valor</label>
                        <b-input-group>
                            <money
                                id="nuValor"
                                v-model="prestacaoContasFinalLancamento.nuValor"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuConfins">Confins</label>
                        <b-input-group>
                            <money
                                id="nuConfins"
                                v-model="prestacaoContasFinalLancamento.nuConfins"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuCsll">CSLL</label>
                        <b-input-group>
                            <money
                                id="nuCsll"
                                v-model="prestacaoContasFinalLancamento.nuCsll"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuInss">INSS</label>
                        <b-input-group>
                            <money
                                id="nuInss"
                                v-model="prestacaoContasFinalLancamento.nuInss"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuIr">IR</label>
                        <b-input-group>
                            <money
                                id="nuIr"
                                v-model="prestacaoContasFinalLancamento.nuIr"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuIss">ISS</label>
                        <b-input-group>
                            <money
                                id="nuIss"
                                v-model="prestacaoContasFinalLancamento.nuIss"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuPis">PIS</label>
                        <b-input-group>
                            <money
                                id="nuPis"
                                v-model="prestacaoContasFinalLancamento.nuPis"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button 
                variant="secondary" 
                @click.stop="fecharModal()"
                >Cancelar</b-button>
                <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1"
                >Salvar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ConveniosServicos from '../../ConveniosServicos'

export default {

    props: {
        operacaoProp: String,
        mostrarModal: {
            type: Boolean, 
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        convenio: {
            type: Object,
        },
        prestacaoContasFinalLancamento: Object,
        desativarBotao: Boolean
    },

    validations: {
        prestacaoContasFinalLancamento: {
            idAcaoConvenio: { required },
            idNaturezaDespesa: { required },
            codTipoPrestacaoContas: { required },
            vcDocumento : { required },
            vcFavorecido: { required },
            dtEmissao: { required },
        }
    },

    data() {
        return {
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            naturezas: [],
            acoes: [],
            codSituacao: 1,
            codTipoPrestacaoContas: 0,
            idAcaoConvenio: 0,
            idNaturezaDespesa: 0,
            dtEmissao: null,
            dtPagamento: null,
            idPrestacaoContasFinal: 0,
            idPrestacaoContasMensal: 0,
            nuConfins: 0,
            nuCsll: 0,
            nuInss: 0,
            nuIr: 0,
            nuIss: 0,
            nuPis: 0,
            nuValor: 0,
            situacao: null,
            tipoPrestacaoContas: null,
            vcDoctoPag: null,
            vcDocumento: null,
            vcFavorecido: null,
            vcObservacao: null,
            tiposPrestacoes: [
                {
                    key: '1',
                    label: 'RECURSOS SEBRAE'
                },
                {
                    key: '2',
                    label: 'CONTRAPARTIDA FINANCEIRA'
                },
                {
                    key: '3',
                    label: 'CONTRAPARTIDA ECONÔMICA'
                }
            ],
        }
    },

    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                this.obterAcoes()
                this.prestacaoContasFinalLancamento.codTipoPrestacaoContas = this.prestacaoContasFinalLancamento.codTipoPrestacaoContas
                this.prestacaoContasFinalLancamento.dtEmissao = this.$moment(this.prestacaoContasFinalLancamento.dtEmissao).format('DD/MM/YYYY')
                this.prestacaoContasFinalLancamento.dtPagamento = this.$moment(this.prestacaoContasFinalLancamento.dtPagamento).format('DD/MM/YYYY')
                this.prestacaoContasFinalLancamento.idAcaoConvenio = this.prestacaoContasFinalLancamento.idAcaoConvenio
                this.obterNaturezas()
                this.prestacaoContasFinalLancamento.idNaturezaDespesa = this.prestacaoContasFinalLancamento.idNaturezaDespesa
                this.prestacaoContasFinalLancamento.idPrestacaoContasFinal = this.prestacaoContasFinalLancamento.idPrestacaoContasFinal
                this.prestacaoContasFinalLancamento.idPrestacaoContasMensal = this.prestacaoContasFinalLancamento.idPrestacaoContasMensal
                this.prestacaoContasFinalLancamento.nuConfins = this.prestacaoContasFinalLancamento.nuConfins
                this.prestacaoContasFinalLancamento.nuCsll = this.prestacaoContasFinalLancamento.nuCsll
                this.prestacaoContasFinalLancamento.nuInss = this.prestacaoContasFinalLancamento.nuInss
                this.prestacaoContasFinalLancamento.nuIr = this.prestacaoContasFinalLancamento.nuIr
                this.prestacaoContasFinalLancamento.nuIss = this.prestacaoContasFinalLancamento.nuIss
                this.prestacaoContasFinalLancamento.nuPis = this.prestacaoContasFinalLancamento.nuPis
                this.prestacaoContasFinalLancamento.nuValor = this.prestacaoContasFinalLancamento.nuValor
                this.prestacaoContasFinalLancamento.situacao = this.prestacaoContasFinalLancamento.situacao
                this.prestacaoContasFinalLancamento.tipoPrestacaoContas = this.prestacaoContasFinalLancamento.tipoPrestacaoContas
                this.prestacaoContasFinalLancamento.vcDoctoPag = this.prestacaoContasFinalLancamento.vcDoctoPag
                this.prestacaoContasFinalLancamento.vcDocumento = this.prestacaoContasFinalLancamento.vcDocumento
                this.prestacaoContasFinalLancamento.vcFavorecido = this.prestacaoContasFinalLancamento.vcFavorecido
                this.prestacaoContasFinalLancamento.vcObservacao = this.prestacaoContasFinalLancamento.vcObservacao 
            } else {
                this.obterAcoes()
                this.obterNaturezas()
            }
        },

        reset() {
            this.prestacaoContasFinalLancamento.codSituacao= 1,
            this.prestacaoContasFinalLancamento.codTipoPrestacaoContas= 0,
            this.prestacaoContasFinalLancamento.idAcaoConvenio= 0,
            this.prestacaoContasFinalLancamento.idNaturezaDespesa= 0,
            this.prestacaoContasFinalLancamento.dtEmissao= null,
            this.prestacaoContasFinalLancamento.dtPagamento= null,
            this.prestacaoContasFinalLancamento.idPrestacaoContasFinal= 0,
            this.prestacaoContasFinalLancamento.idPrestacaoContasMensal= 0,
            this.prestacaoContasFinalLancamento.nuConfins= 0,
            this.prestacaoContasFinalLancamento.nuCsll= 0,
            this.prestacaoContasFinalLancamento.nuInss= 0,
            this.prestacaoContasFinalLancamento.nuIr= 0,
            this.prestacaoContasFinalLancamento.nuIss= 0,
            this.prestacaoContasFinalLancamento.nuPis= 0,
            this.prestacaoContasFinalLancamento.nuValor= 0,
            this.prestacaoContasFinalLancamento.situacao= null,
            this.prestacaoContasFinalLancamento.tipoPrestacaoContas= null,
            this.prestacaoContasFinalLancamento.vcDoctoPag= null,
            this.prestacaoContasFinalLancamento.vcDocumento= null,
            this.prestacaoContasFinalLancamento.vcFavorecido= null,
            this.prestacaoContasFinalLancamento.vcObservacao= null
        },

        obterAcoes() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterAcoesConvenio(this.convenio.idConvenio).then(
                response => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterNaturezas() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterNaturezasPorAcao(this.convenio.idConvenio, this.prestacaoContasFinalLancamento.idAcaoConvenio).then(
                response => {
                if (response) {
                    if (response.success) {
                        this.naturezas = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            }
            )
        },

        fecharModal() {
            this.$emit('fechar')
            this.reset()
        },

        salvar() {
            this.$emit('salvar', this.prestacaoContasFinalLancamento)
            this.$emit('atualizarLista')
            this.reset()
        }
    },

    computed: {
        operacao(){
            if(this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    watch: {
        'prestacaoContasFinalLancamento.idAcaoConvenio'() {
            this.idNaturezaDespesa = null
            this.obterNaturezas()
            this.idAcaoConvenio = null
            if (this.prestacaoContasFinalLancamento.idAcaoConvenio != null && this.prestacaoContasFinalLancamento.idAcaoConvenio.length > 0) 
            {
                this.idAcaoConvenio = this.prestacaoContasFinalLancamento.idAcaoConvenio
            }
        },

        'prestacaoContasFinalLancamento.codTipoPrestacaoContas'() {
            this.codTipoPrestacaoContas = null
            if (this.prestacaoContasFinalLancamento.codTipoPrestacaoContas > 0) 
            {
                this.codTipoPrestacaoContas = this.prestacaoContasFinalLancamento.codTipoPrestacaoContas
            }
        },

        'prestacaoContasFinalLancamento.idNaturezaDespesa'() {
            this.idNaturezaDespesa = null
            if (this.prestacaoContasFinalLancamento.idNaturezaDespesa > 0) 
            {
                this.idNaturezaDespesa = this.prestacaoContasFinalLancamento.idNaturezaDespesa
            }
        },
    },

    created(){
        console.log(this.prestacaoContasFinalLancamento)
    }
}
</script>